import { useMediaSize } from "@/hooks/useMediaSize";
import { NavList } from "@/routes/User";
import { getDisplayName } from "@/utils";
import { List, message } from "antd";
import { User } from "authing-js-sdk";
import classnames from "classnames";
import qs from "qs";
import React, { useContext, useMemo } from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import ImageComponent from "../ImageComponent";
import styles from "./styles.module.less";
import "./styles.less";
import { useLocationSearch } from "@/hooks/useLocationSearch";
import { useNavigate } from "react-router";

export const PSCCHeader: FC<{
  user: User | null;
}> = ({ user }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const search = useLocationSearch();
  const navlist = useContext(NavList);

  const { isPhoneMedia } = useMediaSize();

  const nav = useMemo(() => {
    const unRender: string[] = ["basic"];
    if (isPhoneMedia) {
      return navlist.filter((item) => !unRender.includes(item.key));
    }
    return navlist;
  }, [isPhoneMedia, navlist]);

  const current = useMemo(() => {
    return (qs.parse(search).user_active_tab as string) || "basic";
  }, [search]);

  const imageSize = useMemo(() => (isPhoneMedia ? 58 : 102), [isPhoneMedia]);

  return (
    <div className={styles.PSCCHeader}>
      <div className={classnames(styles.card, styles.userInfo)}>
        <ImageComponent
          src={user?.photo ?? ""}
          style={{
            width: imageSize,
            height: imageSize,
            borderRadius: 51,
            border: "1px solid #EEEEEE",
          }}
          onChange={async (photo) => {
            await window.__authing__.updateProfile({ photo });
            message.success(t("common.updateSuccess"));
          }}
        />
        <span className={styles.title}>{getDisplayName(user!!) || "--"}</span>
      </div>

      {nav.length !== 0 && (
        <div className={classnames(styles.menu, styles.card)}>
          <List>
            {nav.map(({ key, label }, index) => (
              <List.Item
                key={key}
                className={classnames(
                  styles.item,
                  {
                    [styles.active]: current === key,
                  },
                  `nav_list_item_${index}`
                )}
                onClick={() => {
                  navigate(
                    `/u?${qs.stringify({
                      ...qs.parse(search),
                      user_active_tab: key,
                    })}`
                  );
                }}
              >
                <div className={styles.itemContent}>{label}</div>
              </List.Item>
            ))}
          </List>
        </div>
      )}
    </div>
  );
};
